"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var numberFormat_1 = __importDefault(require("../../utils/numberFormat"));
var getCurrencySymbol_1 = __importDefault(require("../../utils/getCurrencySymbol"));
var CarInfoCreditItem = function (_a) {
    var label = _a.label, value = _a.value, currency = _a.currency;
    var currencySymbol = getCurrencySymbol_1.default(currency);
    return (react_1.default.createElement("div", { className: "azgazui__card-credit-item" },
        react_1.default.createElement("div", { className: "azgazui__card-credit-label" }, label),
        react_1.default.createElement("div", { className: "azgazui__card-credit-month" },
            numberFormat_1.default()(value),
            react_1.default.createElement("span", { className: "azgazui__card-credit-currency" }, " " + currencySymbol + "/\u043C\u0435\u0441."))));
};
exports.default = CarInfoCreditItem;
